<template>
  <v-card
    :class="[
      'card-color--'+color,
      (fill) ? 'card-fill card-fill--'+fillColor : 'card--border-left',
      { 'flex-column': fill }
    ]"
    class="base-quantity-card align-center"
  >
    <div v-if="$slots.default">
      <slot />
      <v-divider class="ml-0 mr-0" />
    </div>
    <div class="d-flex align-center">
      <div class="ml-1 mr-2">
        <span
          class="font-xx-small font-weight-bold"
          :class="{'font-32px': displayedCount > 999}"
        >{{ displayedCount }}</span>
      </div>
      <div class="fx-2 flex-column">
        <span class="font-default-size font-weight-bold">{{ title }}</span><br>
        <span class="font-x-small grey--text">{{ message }}</span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BaseQuantitySmallCard',
  props: {
    color: {
      type: String,
      default: 'dark-blue'
    },
    fill: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: 'dark-blue'
    },
    count: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  },
  computed: {
    displayedCount () {
      return this.count < 10 ? `0${this.count}` : this.count
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./src/styles/variables";

  .base-quantity-card  {
    min-height: 23px;
    max-height: 47px;
    padding: 10px;
  }
  .card--border-left {
    border-left: 15px solid;
    padding: 0;
  }
  .card-fill {
    max-height: 80px;
  }
  .card-color--dark-blue {
    color: $dark-blue !important;
    border-color: $dark-blue !important;
  }
  .card-fill--dark-blue {
    background-color: rgba($dark-blue, 0.1) !important;
  }
  .card-color--dark-green {
    color: $dark-green !important;
    border-color: $dark-green !important;
  }
  .card-fill--dark-green {
    background-color: rgba($dark-green, 0.1) !important;
  }
  .card-color--orange {
    color: $orange !important;
    border-color: $orange !important;
  }
  .card-color--red {
    color: $red !important;
    border-color: $red !important;
  }
  .card-fill--orange {
    background-color: rgba($orange, 0.1) !important;
  }
</style>
